(ns frontend.view.kpi-reporting.kpi-company-reports.db
  (:require [frontend.state.current-session :as session]
            [frontend.db :as app-db]
            [reagent.core :as r]))

(defonce state (r/cursor app-db/views [:kpi-company-reports]))
(defonce mode (r/cursor state [:mode]))
(defonce state-atom (r/cursor state [:state-atom]))
(defonce entities (r/cursor state [:entities]))
